import { CustomWindowExport } from '@benefitsui/app/shared/interfaces/customWindow';
import { Injectable } from '@angular/core';
import { AnalyticsEvent, AnalyticsPageViewEvent, AnalyticsService, AnalyticsTimingEvent } from '@dxo/ng-swift-ui';
import { Defaults } from '@benefitsui/app/shared/defaults/defaults';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService extends AnalyticsService {
  private get dataLayer() {
    return CustomWindowExport.dataLayer ?? [];
  }

  /**
   * Send an arbitrary analytics event
   */
  trackEvent({ category, action, label, value }: AnalyticsEvent) {
    this.dataLayer.push({
      event: 'gaEvent',
      gaCategory: category,
      gaAction: action,
      gaLabel: label ?? Defaults.stringEmpty,
      gaValue: (value ?? Defaults.sentinelValue).toString()
    });
  }

  /**
   * Send a pageview event
   */
  trackPageView(event: AnalyticsPageViewEvent) {
    this.dataLayer.push({
      event: 'gaPageView',
      totalDuration: (event.pageLoadDurationMs ?? Defaults.sentinelValue).toString(),
      navDuration: (event.navigationDurationMs ?? Defaults.sentinelValue).toString(),
      dataDuration: (event.dataLoadDurationMs ?? Defaults.sentinelValue).toString()
    });
  }

  /**
   * Send a timing event
   */
  trackTiming({ category, value, label, ...e }: AnalyticsTimingEvent) {
    this.dataLayer.push({
      event: 'gaTiming',
      gaCategory: category,
      gaVar: e.var,
      gaLabel: label ?? Defaults.stringEmpty,
      gaValue: (value ?? Defaults.sentinelValue).toString()
    });
  }
}
